import { enUS, thTH } from "@mui/material/locale";

export const allLangs = [
  {
    label: "English",
    value: "en",
    systemValue: enUS,
    icon: "flagpack:gb-nir",
  },
  {
    label: "Thai",
    value: "th",
    systemValue: thTH,
    icon: "flagpack:th",
  },
];

export const defaultLang = allLangs[0];
